// Which licensed modules are switched on for this client (Commercial Setup → Plans).
//
// Layout loads the list once and publishes it here. Everything else reads it:
//  - `useModuleAccess()` in a component → `moduleOn('risk_assessment')`, re-renders on change;
//  - `isModuleOn(key)` anywhere else;
//  - any element marked `data-module="<key>"` is hidden while that module is off, so a
//    button belonging to another module needs only that attribute.
import { useEffect, useState } from 'react';

let modules = null;
const listeners = new Set();
const STYLE_ID = 'module-access-style';

export const isModuleOn = (key) => !modules || modules[key] !== false;

export const publishModuleAccess = (next) => {
  modules = next && typeof next === 'object' ? next : null;

  let style = document.getElementById(STYLE_ID);
  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }
  const off = Object.keys(modules || {}).filter((key) => modules[key] === false);
  style.textContent = off.length
    ? `${off.map((key) => `[data-module="${key}"]`).join(',')}{display:none !important;}`
    : '';

  listeners.forEach((listener) => listener());
};

export const useModuleAccess = () => {
  const [, rerender] = useState(0);
  useEffect(() => {
    const listener = () => rerender((n) => n + 1);
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);
  return isModuleOn;
};

// Commercial Setup fires this after a save so the sidebar and pages pick up the new plan.
export const MODULE_ACCESS_CHANGED = 'commercial-runtime-changed';
